import request from "@/utils/request";

export function login(data) {
  return request({
    url: "/auth/login",
    method: "post",
    data
  });
}

export function getInfo() {
  return request({
    url: "/auth/me",
    method: "get"
  });
}

export function logout() {
  return request({
    url: "/auth/logout",
    method: "post"
  });
}

export function refresh() {
  return request({
    url: "/auth/refresh",
    method: "post"
  });
}


export function downloadExcel(type = "login") {
  return request({
    url: "/users/download?type="+type,
    method: "post"
  }, {
    responseType: 'blob'
  });
}

export function uploadCsv(formData) {
  return request.post('/users/upload',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
}

export function flagUser(login, data) {
  return request({
    url: "/users/flag/" + login,
    method: "put",
    data
  });
}
